import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";

import * as actions from "../../../../store/actions";
import constants from "../../../../constants";

import Button from "../../../../components/formElements/button/Button";
import DateTimePicker from "../../../../components/formElements/datepicker/DateTimePicker";
import SelectInput from "../../../../components/formElements/selectInput/SelectInput";
import Row from "../../../../components/uiElements/grid/Row";
import Col from "../../../../components/uiElements/grid/Col";

/* eslint-disable jsx-a11y/anchor-is-valid */
const AvailibilityCalendar = ({
  practiceDetails,
  addSlots,
  setSlots,
  removeSlots,
  addWorkingDays,
  addCalendar,
  removeCalendar,
  addAcceptUntil,
}) => {
  return (
    <>
      {practiceDetails.calendar.map((cal, calId) => (
        <>
          <Row className="mt-n4">
            <Col size={["md-12"]}>
              <DateTimePicker
                mode="date"
                placeholder="Start Date"
                previousDate={
                  calId > 0 && practiceDetails.calendar[calId - 1].endDate
                }
                value={cal.startDate}
                onChange={date => addAcceptUntil(date, calId, "start")}
              />
            </Col>
            <Col size={["md-12"]}>
              <DateTimePicker
                mode="date"
                placeholder="End Date"
                sDate={cal.startDate}
                previousDate={
                  calId > 0 && practiceDetails.calendar[calId - 1].endDate
                }
                value={cal.endDate}
                onChange={date => addAcceptUntil(date, calId, "end")}
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col size={["md-12"]} className="mb-4">
              <div className="border-bottom"></div>
            </Col>
            <Col size={["md-12"]}>
              {constants.WEEK_DAYS.map(day => (
                <span
                  style={{
                    paddingRight: 25,
                  }}
                  onClick={() => addWorkingDays(day.value, calId)}
                >
                  <span
                    style={{
                      borderRadius: "100%",
                      backgroundColor: cal.workingDays.includes(day.value)
                        ? "var(--faint-color)"
                        : "#f7f7f7",
                      padding: 5,
                      paddingLeft: 10,
                      paddingRight: 10,
                      cursor: "pointer",
                    }}
                  >
                    {day.label}
                  </span>
                </span>
              ))}
            </Col>
          </Row>
          <Row className="mb-4">
            <Col size={["md-6"]} className="mb-n3">
              <span
                style={{
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                Morning
              </span>
            </Col>
          </Row>
          {cal.morningSlots.length > 1 ? (
            cal.morningSlots.map((slot, index) => (
              <Row className="mb-2">
                <Col>
                  <button
                    onClick={() => removeSlots("morningSlots", index, calId)}
                    type="button"
                    className="close float-right"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </Col>
                <Col size={["md-6"]}>
                  <DateTimePicker
                    mode="time"
                    id="startTime"
                    period="morning"
                    eTime={index > 0 && cal.morningSlots[index - 1].endTime}
                    slots={index > 0 && cal.morningSlots}
                    value={slot.startTime}
                    onChange={time =>
                      setSlots(
                        "morningSlots",
                        { startTime: time },
                        index,
                        calId
                      )
                    }
                  />
                </Col>
                <Col size={["md-6"]}>
                  <DateTimePicker
                    mode="time"
                    id="endTime"
                    period="morning"
                    sTime={slot?.startTime}
                    slots={index > 0 && cal.morningSlots}
                    value={slot.endTime}
                    onChange={time =>
                      setSlots("morningSlots", { endTime: time }, index, calId)
                    }
                  />
                </Col>
                <Col size={["md-12"]} className="mb-2">
                  <SelectInput
                    isSearchable={false}
                    placeholder="Slot Duration"
                    options={[
                      { label: "20 Min", value: "20" },
                      { label: "40 Min", value: "40" },
                      { label: "60 Min", value: "60" },
                    ]}
                    value={slot.duration}
                    onChange={date =>
                      setSlots("morningSlots", { duration: date }, index, calId)
                    }
                  />
                </Col>
                <Col className="mb-2">
                  {cal?.morningSlots?.length - 1 === index &&
                    cal.morningSlots &&
                    !(
                      cal?.morningSlots[cal.morningSlots.length - 1]?.endTime
                        ?.hour === 12 &&
                      cal?.morningSlots[cal.morningSlots.length - 1]?.endTime
                        ?.minutes === 0
                    ) && (
                      <a
                        onClick={() => addSlots("morningSlots", calId)}
                        className="calendarLink"
                      >
                        {" "}
                        {"Add"}{" "}
                      </a>
                    )}
                </Col>
              </Row>
            ))
          ) : (
            <Row>
              {cal?.morningSlots[0]?.startTime &&
                cal?.morningSlots[0]?.endTime &&
                cal?.morningSlots[0]?.duration && (
                  <Col>
                    <button
                      onClick={() => removeSlots("morningSlots", 0, calId)}
                      type="button"
                      className="close float-right"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </Col>
                )}
              <Col size={["md-6"]}>
                <DateTimePicker
                  mode="time"
                  id="startTime"
                  period="morning"
                  // eTime={cal?.morningSlots[0]?.endTime}
                  value={cal?.morningSlots[0]?.startTime}
                  onChange={time =>
                    setSlots("morningSlots", { startTime: time }, 0, calId)
                  }
                />
              </Col>
              <Col size={["md-6"]}>
                <DateTimePicker
                  mode="time"
                  id="endTime"
                  period="morning"
                  sTime={cal?.morningSlots[0]?.startTime}
                  value={cal?.morningSlots[0]?.endTime}
                  onChange={time =>
                    setSlots("morningSlots", { endTime: time }, 0, calId)
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mb-2">
                <SelectInput
                  isSearchable={false}
                  placeholder="Slot Duration"
                  options={[
                    { label: "20 Min", value: "20" },
                    { label: "40 Min", value: "40" },
                    { label: "60 Min", value: "60" },
                  ]}
                  defaultValue=""
                  value={cal?.morningSlots[0]?.duration || ""}
                  onChange={date =>
                    setSlots("morningSlots", { duration: date }, 0, calId)
                  }
                />
              </Col>
              <Col className="mb-2">
                {cal.morningSlots &&
                  cal?.morningSlots[0]?.startTime &&
                  cal?.morningSlots[0]?.endTime &&
                  cal?.morningSlots[0]?.duration &&
                  !(
                    cal?.morningSlots[0]?.endTime?.hour === 12 &&
                    cal?.morningSlots[0]?.endTime?.minutes === 0
                  ) && (
                    <a
                      onClick={() => addSlots("morningSlots", calId)}
                      className="calendarLink"
                    >
                      {" "}
                      {"Add"}{" "}
                    </a>
                  )}
              </Col>
            </Row>
          )}
          <Row className="mb-2">
            <Col size={["md-12"]}>
              <div className="border-bottom"></div>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col size={["md-6"]} className="mb-n3">
              <span
                style={{
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                Afternoon
              </span>
            </Col>
          </Row>

          {cal.afternoonSlots.length > 1 ? (
            cal.afternoonSlots.map((slot, index) => (
              <Row className="mb-2">
                <Col>
                  <button
                    onClick={() => removeSlots("afternoonSlots", index, calId)}
                    type="button"
                    className="close float-right"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </Col>
                <Col size={["md-6"]}>
                  <DateTimePicker
                    mode="time"
                    id="startTime"
                    period="afternoon"
                    eTime={index > 0 && cal.afternoonSlots[index - 1].endTime}
                    slots={index > 0 && cal.afternoonSlots}
                    value={slot.startTime}
                    onChange={time =>
                      setSlots(
                        "afternoonSlots",
                        { startTime: time },
                        index,
                        calId
                      )
                    }
                  />
                </Col>
                <Col size={["md-6"]}>
                  <DateTimePicker
                    mode="time"
                    id="endTime"
                    period="afternoon"
                    sTime={slot?.startTime}
                    slots={index > 0 && cal.afternoonSlots}
                    value={slot.endTime}
                    onChange={time =>
                      setSlots(
                        "afternoonSlots",
                        { endTime: time },
                        index,
                        calId
                      )
                    }
                  />
                </Col>
                <Col size={["md-12"]} className="mb-2">
                  <SelectInput
                    isSearchable={false}
                    placeholder="Slot Duration"
                    options={[
                      { label: "20 Min", value: "20" },
                      { label: "40 Min", value: "40" },
                      { label: "60 Min", value: "60" },
                    ]}
                    value={slot.duration}
                    onChange={date =>
                      setSlots(
                        "afternoonSlots",
                        { duration: date },
                        index,
                        calId
                      )
                    }
                  />
                </Col>
                <Col className="mb-2">
                  {cal?.afternoonSlots?.length - 1 === index &&
                    cal.afternoonSlots &&
                    !(
                      cal?.afternoonSlots[cal.afternoonSlots.length - 1]
                        ?.endTime?.hour === 18 &&
                      cal?.afternoonSlots[cal.afternoonSlots.length - 1]
                        ?.endTime?.minutes === 0
                    ) && (
                      <a
                        onClick={() => addSlots("afternoonSlots", calId)}
                        className="calendarLink"
                      >
                        {" "}
                        {"Add"}{" "}
                      </a>
                    )}
                </Col>
              </Row>
            ))
          ) : (
            <Row>
              {cal?.afternoonSlots[0]?.startTime &&
                cal?.afternoonSlots[0]?.endTime &&
                cal?.afternoonSlots[0]?.duration && (
                  <Col className="mt-n3">
                    <button
                      onClick={() => removeSlots("afternoonSlots", 0, calId)}
                      type="button"
                      className="close float-right"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </Col>
                )}
              <Col size={["md-6"]}>
                <DateTimePicker
                  mode="time"
                  id="startTime"
                  period="afternoon"
                  // eTime={cal?.morningSlots[0]?.endTime}
                  value={cal?.afternoonSlots[0]?.startTime}
                  onChange={time =>
                    setSlots("afternoonSlots", { startTime: time }, 0, calId)
                  }
                />
              </Col>
              <Col size={["md-6"]}>
                <DateTimePicker
                  mode="time"
                  id="endTime"
                  period="afternoon"
                  sTime={cal?.afternoonSlots[0]?.startTime}
                  value={cal?.afternoonSlots[0]?.endTime}
                  onChange={time =>
                    setSlots("afternoonSlots", { endTime: time }, 0, calId)
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mb-2">
                <SelectInput
                  isSearchable={false}
                  placeholder="Slot Duration"
                  options={[
                    { label: "20 Min", value: "20" },
                    { label: "40 Min", value: "40" },
                    { label: "60 Min", value: "60" },
                  ]}
                  defaultValue=""
                  value={cal?.afternoonSlots[0]?.duration || ""}
                  onChange={date =>
                    setSlots("afternoonSlots", { duration: date }, 0, calId)
                  }
                />
              </Col>
              <Col className="mb-2">
                {cal.afternoonSlots &&
                  cal?.afternoonSlots[0]?.startTime &&
                  cal?.afternoonSlots[0]?.endTime &&
                  cal?.afternoonSlots[0]?.duration &&
                  !(
                    cal?.afternoonSlots[0]?.endTime?.hour === 18 &&
                    cal?.afternoonSlots[0]?.endTime?.minutes === 0
                  ) && (
                    <a
                      onClick={() => addSlots("afternoonSlots", calId)}
                      className="calendarLink"
                    >
                      {" "}
                      {"Add"}{" "}
                    </a>
                  )}
              </Col>
            </Row>
          )}
          <Row className="mb-2">
            <Col size={["md-12"]}>
              <div className="border-bottom"></div>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col size={["md-6"]} className="mb-n3">
              <span
                style={{
                  color: "black",
                  fontWeight: "bold",
                }}
              >
                Evening
              </span>
            </Col>
          </Row>
          {cal.eveningSlots.length > 1 ? (
            cal.eveningSlots.map((slot, index) => (
              <Row className="mb-2">
                <Col>
                  <button
                    onClick={() => removeSlots("eveningSlots", index, calId)}
                    type="button"
                    className="close float-right"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </Col>
                <Col size={["md-6"]}>
                  <DateTimePicker
                    mode="time"
                    id="startTime"
                    period="evening"
                    eTime={index > 0 && cal.eveningSlots[index - 1].endTime}
                    slots={index > 0 && cal.eveningSlots}
                    value={slot.startTime}
                    onChange={time =>
                      setSlots(
                        "eveningSlots",
                        { startTime: time },
                        index,
                        calId
                      )
                    }
                  />
                </Col>
                <Col size={["md-6"]}>
                  <DateTimePicker
                    mode="time"
                    id="endTime"
                    period="evening"
                    sTime={slot?.startTime}
                    slots={index > 0 && cal.eveningSlots}
                    value={slot.endTime}
                    onChange={time =>
                      setSlots("eveningSlots", { endTime: time }, index, calId)
                    }
                  />
                </Col>
                <Col size={["md-12"]} className="mb-2">
                  <SelectInput
                    isSearchable={false}
                    placeholder="Slot Duration"
                    options={[
                      { label: "20 Min", value: "20" },
                      { label: "40 Min", value: "40" },
                      { label: "60 Min", value: "60" },
                    ]}
                    value={slot.duration}
                    onChange={date =>
                      setSlots("eveningSlots", { duration: date }, index, calId)
                    }
                  />
                </Col>
                <Col className="mb-2">
                  {cal?.eveningSlots?.length - 1 === index &&
                    cal.eveningSlots &&
                    !(
                      cal?.eveningSlots[cal.eveningSlots.length - 1]?.endTime
                        ?.hour === 23 &&
                      cal?.eveningSlots[cal.eveningSlots.length - 1]?.endTime
                        ?.minutes === 0
                    ) && (
                      <a
                        onClick={() => addSlots("eveningSlots", calId)}
                        className="calendarLink"
                      >
                        {" "}
                        {"Add"}{" "}
                      </a>
                    )}
                </Col>
              </Row>
            ))
          ) : (
            <Row>
              {cal?.eveningSlots[0]?.startTime &&
                cal?.eveningSlots[0]?.endTime &&
                cal?.eveningSlots[0]?.duration && (
                  <Col className="mt-n3">
                    <button
                      onClick={() => removeSlots("eveningSlots", 0, calId)}
                      type="button"
                      className="close float-right"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </Col>
                )}
              <Col size={["md-6"]}>
                <DateTimePicker
                  mode="time"
                  id="startTime"
                  period="evening"
                  // eTime={cal?.morningSlots[0]?.endTime}
                  value={cal?.eveningSlots[0]?.startTime}
                  onChange={time =>
                    setSlots("eveningSlots", { startTime: time }, 0, calId)
                  }
                />
              </Col>
              <Col size={["md-6"]}>
                <DateTimePicker
                  mode="time"
                  id="endTime"
                  period="evening"
                  sTime={cal?.eveningSlots[0]?.startTime}
                  value={cal?.eveningSlots[0]?.endTime}
                  onChange={time =>
                    setSlots("eveningSlots", { endTime: time }, 0, calId)
                  }
                />
              </Col>
              <Col size={["md-12"]} className="mb-2">
                <SelectInput
                  isSearchable={false}
                  placeholder="Slot Duration"
                  options={[
                    { label: "20 Min", value: "20" },
                    { label: "40 Min", value: "40" },
                    { label: "60 Min", value: "60" },
                  ]}
                  defaultValue=""
                  value={cal?.eveningSlots[0]?.duration || ""}
                  onChange={date =>
                    setSlots("eveningSlots", { duration: date }, 0, calId)
                  }
                />
              </Col>
              <Col className="mb-2">
                {cal.eveningSlots &&
                  cal?.eveningSlots[0]?.startTime &&
                  cal?.eveningSlots[0]?.endTime &&
                  cal?.eveningSlots[0]?.duration &&
                  !(
                    cal?.eveningSlots[0]?.endTime?.hour === 23 &&
                    cal?.eveningSlots[0]?.endTime?.minutes === 0
                  ) && (
                    <a
                      onClick={() => addSlots("eveningSlots", calId)}
                      className="calendarLink"
                    >
                      {" "}
                      {"Add"}{" "}
                    </a>
                  )}
              </Col>
            </Row>
          )}

          {
            practiceDetails?.calendar?.length - 1 === calId &&
            <div className="d-flex justify-content-center align-items-center text-center">
              <Button
                type="info"
                indicatorButton
                className={`w-50 ${practiceDetails?.calendar?.length > 1 ? "mb-2" : "mb-5"}`}
                onClick={() => addCalendar()}
                label={"Add"}
              />
            </div>
          }
          {
            practiceDetails?.calendar?.length > 1 &&
            <div className="d-flex justify-content-center align-items-center text-center">
              <Button
                type="info"
                indicatorButton
                className="w-50 mb-5"
                onClick={() => removeCalendar(calId)}
                label={"Remove"}
              />
            </div>
          }
          {practiceDetails?.calendar?.length - 1 !== calId && (
            <Row className="mb-5 mt-n4">
              <Col size={["md-12"]}>
                <div className="border-bottom"></div>
              </Col>
            </Row>
          )}
        </>
      ))}
    </>
  );
};

const mapStoreToProps = ({ onboarding }) => ({
  practiceDetails: onboarding.practiceDetails,
});

const mapDispatchToProps = dispatch => ({
  addSlots: (period, calId) => dispatch(actions.addSlots(period, calId)),
  setSlots: (period, updatedData, index, calId) =>
    dispatch(actions.setSlots(period, updatedData, index, calId)),
  removeSlots: (period, index, calId) =>
    dispatch(actions.removeSlots(period, index, calId)),
  addWorkingDays: (workingDay, calId) =>
    dispatch(actions.addWorkingDays(workingDay, calId)),
  addCalendar: () => dispatch(actions.addCalendar()),
  removeCalendar: calId => dispatch(actions.removeCalendar(calId)),
  addAcceptUntil: (data, calId, date) =>
    dispatch(actions.addAcceptUntil(data, calId, date)),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(AvailibilityCalendar)
);
